<div
    class="flex gap-x-1"
    [class]="shouldOpenedTube() ? 'items-stretch' : 'items-center'">
    @if (side() === CableDirectionEnum.RIGHT) {
        <ng-container *ngTemplateOutlet="tubePlusOrDetailed" />
    }
    <div
        [class]="`boxPlan__tube boxPlan__tube__${side()}`"
        [style.background-color]="tubeColor()"
        [style.color]="fontColor()"
        (click)="toggleTube()">
        <p>{{ 'synopticPlan.tube' | transloco }} {{ tubeNumber() }}</p>
        @if (shouldOpenedTube()) {
            <p>
                <span
                    class="font-light"
                    [style.color]="fontColor()"
                    >{{ 'synopticPlan.tubeColor' | transloco }}</span
                >{{ tubeColor() }}
            </p>
            <p>
                <span
                    class="font-light"
                    [style.color]="fontColor()"
                    >{{ 'synopticPlan.fiberType' | transloco }}</span
                >G567A2
            </p>
        }
    </div>
    @if (side() === CableDirectionEnum.LEFT) {
        <ng-container *ngTemplateOutlet="tubePlusOrDetailed" />
    }
</div>

<ng-template #tubePlusOrDetailed>
    @if (shouldOpenedTube()) {
        <div class="flex flex-col gap-y-1">
            @for (fiber of fibers(); track fiber.code) {
                <app-side-fiber-edit
                    [cableCode]="cableCode()"
                    [cassettes]="cassettes()"
                    [fiber]="fiber"
                    [planType]="planType()"
                    [side]="side()"
                    [tubeNumber]="tubeNumber()" />
            }
        </div>
    } @else {
        <button
            class="plusButton"
            [class.plusButton_fibers_assigned]="!isTubeSelectionEnabled()"
            [class.plusButton_fibers_free]="isTubeSelectionEnabled()"
            [class.plusButton_selected]="isTubeSelected()"
            [class.plusButton_unselected]="!isTubeSelected() && isTubeSelectionEnabled()"
            [disabled]="!isTubeSelectionEnabled()"
            [id]="`boxPlan_tube_${cableCode()}_${tubeNumber()}_${side()}`"
            (click)="selectTube()">
            <fa-icon
                [class]="isTubeSelectionEnabled() ? 'text-custom-blue' : 'text-custom-dark-grey'"
                [icon]="['fas', 'plus']" />
        </button>
    }
</ng-template>
